<template>
  <div class="tv-management">
    <vs-tabs alignment="fixed" v-model="activeTab">
       <vs-tab label="Channels" icon="live_tv">
        <div class="tab-content">
          <channelsVue/>
        </div>
      </vs-tab>
      <vs-tab label="Packages" icon="inventory_2">
        <div class="tab-content">
          <packagesVue/>
        </div>
      </vs-tab>
     
      <vs-tab label="Slider" icon="view_carousel">
        <div class="tab-content">
          <sliderVue/>
        </div>
      </vs-tab>
      <vs-tab label="Schedule" icon="schedule">
        <div class="tab-content">
          <scheduleVue/>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import packagesVue from './packages.vue';
import channelsVue from './channels.vue';
import scheduleVue from './schedule.vue';
import sliderVue from './slider.vue';

export default {
  components: { packagesVue, channelsVue, scheduleVue, sliderVue },
  data() {
    return {
      activeTab: 0
    }
  }
}
</script>
<style lang="scss" scoped>
.tv-management {
  padding: 1rem;
}
.tab-content {
  padding: 1rem 0;
}
</style>